export default __webpack_public_path__ + "static/media/banner2.8896c792.jpg";